import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';
import '../styles/common/Download.css';

// Встановіть посилання на магазини тут
const IOS_URL = 'https://apps.apple.com/us/app/bigmat/id6767524274';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=edera.bigmat';

const StoreColumn = ({ url, storeName, storeLabel, icon }) => (
  <div className="download__column">
    <div className="download__store-icon">{icon}</div>
    <h3 className="download__store-name">{storeName}</h3>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="download__store-btn"
    >
      {storeLabel}
    </a>
    <div className="download__qr-wrapper">
      <QRCodeSVG
        value={url}
        size={160}
        bgColor="#ffffff"
        fgColor="#1a1a1a"
        level="M"
      />
      <p className="download__qr-hint">Відскануйте камерою</p>
    </div>
  </div>
);

export default function DownloadPage() {
  const columns = [];

  if (IOS_URL) {
    columns.push(
      <StoreColumn
        key="ios"
        url={IOS_URL}
        storeName="iPhone / iPad"
        storeLabel="Завантажити в App Store"
        icon={
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
        }
      />
    );
  }

  if (ANDROID_URL) {
    columns.push(
      <StoreColumn
        key="android"
        url={ANDROID_URL}
        storeName="Android"
        storeLabel="Завантажити в Google Play"
        icon={
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5S22 17.33 22 16.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0 0 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 0 0 6 7h12a5.983 5.983 0 0 0-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"/>
          </svg>
        }
      />
    );
  }

  return (
    <div className="page-container download-page">
      <Header />
      <div className="download__banner">
        <h1 className="download__title">Завантажити застосунок БігМат</h1>
        <p className="download__subtitle">
          Безоплатний застосунок для вивчення математики — встановіть на свій пристрій прямо зараз.
        </p>
        <div className="download__columns">
          {columns}
        </div>
      </div>
      <Footer text="Коли математика не лякає, а надихає" shouldDecorate={true} />
    </div>
  );
}
